import React from 'react';
import { useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const routeLabels: Record<string, string> = {
  '/': 'Dashboard',
  '/dashboard': 'Dashboard',
  '/photos': 'Progress Photos',
  '/achievements': 'Achievements',
  '/analytics': 'Analytics',
  '/ai-coach': 'AI Coach',
  '/ai-coach-fitness': 'AI Fitness Coach',
  '/activity-tracker': 'Activity Tracker',
  '/profile': 'Profile Settings'
};

export const EnhancedBreadcrumbs: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Generate breadcrumb segments
  const pathSegments = currentPath.split('/').filter(Boolean);
  
  const breadcrumbs: Array<{ label: string; path: string; icon?: React.ElementType }> = [
    { label: 'Home', path: '/', icon: Home }
  ];

  // Build breadcrumbs from path segments
  let currentPathBuilt = '';
  pathSegments.forEach((segment) => {
    currentPathBuilt += `/${segment}`;
    const label = routeLabels[currentPathBuilt] || segment.charAt(0).toUpperCase() + segment.slice(1);
    breadcrumbs.push({
      label,
      path: currentPathBuilt
    });
  });

  // Don't show breadcrumbs for home page
  if (currentPath === '/' || currentPath === '/dashboard') {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="bg-muted/30 border-b border-border px-6 py-3">
      <ol className="flex items-center space-x-1 text-sm">
        {breadcrumbs.map((crumb, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const isFirst = index === 0;

          return (
            <li key={crumb.path} className="flex items-center">
              {!isFirst && (
                <ChevronRight className="h-4 w-4 text-muted-foreground mx-2" />
              )}
              
              {isLast ? (
                <span className="font-medium text-foreground flex items-center gap-1">
                  {isFirst && crumb.icon && <crumb.icon className="h-4 w-4" />}
                  {crumb.label}
                </span>
              ) : (
                <NavLink
                  to={crumb.path}
                  className="text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1"
                >
                  {isFirst && crumb.icon && <crumb.icon className="h-4 w-4" />}
                  {crumb.label}
                </NavLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};